// import axios from 'axios';

var Contato = {};

function val(selector) {
  return $(selector).val() || '';
}

Contato.getData = function getData() {
  let data = {};
  data.nome = val('#inp-nome');
  data.email = val('#inp-email');
  data.telefone = val('#inp-telefone');
  data.celular = val('#inp-celular');
  data.cep = val('#inp-cep');
  data.endereco = val('#inp-endereco');
  data.numero = val('#inp-numero');
  data.complemento = val('#inp-complemento');
  data.cidade = val('#inp-cidade');
  data.estado = val('#inp-estado');
  data.motivo = val('#inp-motivo');
  data.mensagem = '';

  data.relacionado_a = val('[name="relacionado_a"]');

  if(true || data.relacionado_a == 'produto') {
    data.mensagem = val('#inpp-mensagem');
    
    data.produto = {};
    data.produto.nome = val('#inpp-nome-produto');
    data.produto.peso_bebe = val('#inpp-peso-bebe');
    data.produto.fabricacao = val('#inpp-fabricacao');
    data.produto.validade = val('#inpp-validade');
    data.produto.lote = val('#inpp-lote');
    data.produto.n_defeitos = val('#inpp-n-defeitos');
  }

  return data;
};

Contato.loading = function loading(isLoading = true) {
  $('.formulario-retorno-erro').hide();
  $('.formulario-retorno-sucesso').hide();
  
  if(isLoading) {
    $('#btn-enviar-contato').attr('disabled', true);
    $('.formulario-retorno-carregando').show();
  } else {
    $('#btn-enviar-contato').attr('disabled', false);
    $('.formulario-retorno-carregando').hide();
  }
};

Contato.sucesso = function sucesso() {
  Contato.loading(false);
  $('.formulario-retorno-sucesso').fadeIn();
};

Contato.erro = function erro() {
  Contato.loading(false);
  $('.formulario-retorno-erro').fadeIn();
};

Contato.handleEnviar = function handleEnviar() {
  let jsonData = Contato.getData();

  Contato.loading(true);
  $.post('enviar-contato.php', $.param(jsonData), function(response) {
    if(response.success) {
      Contato.sucesso();
    } else {
      Contato.erro();
    }
  }).fail(function() {
    Contato.erro();
  });
};




$(document).ready(function() {
  if(!$('.page-contato').length) return;

  $('#btn-enviar-contato').click(() => Contato.handleEnviar());

  $('select').selectric();

  $('[name="relacionado_a"]').on('click change',function() {
    let relVal = $('[name="relacionado_a"]:checked').val();
    console.log('contato ', relVal);
    $('.page-contato').attr('data-contato', relVal);
  });
  $('[name="relacionado_a"]').trigger('change');
});
